import { z } from 'zod'

export const PlantAssessmentDocumentSchema = z.looseObject({
  id: z.string(),
  plantAssessmentID: z.string(),
  title: z.string(),
  kind: z.string(),
  status: z.enum(['draft', 'published']),
  objectName: z.string().nullable(),
  hasSource: z.boolean(),
  contentType: z.string(),
  sizeBytes: z.number(),
  isPublic: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  createdByUserID: z.string().nullable()
})

export type PlantAssessmentDocument = z.infer<typeof PlantAssessmentDocumentSchema>

export const CreatePlantAssessmentDocumentResponseSchema = z.looseObject({
  id: z.string()
})

export type CreatePlantAssessmentDocumentResponse = z.infer<
  typeof CreatePlantAssessmentDocumentResponseSchema
>

export const UpdatePlantAssessmentDocumentResponseSchema = z.looseObject({
  document: PlantAssessmentDocumentSchema
})

export type UpdatePlantAssessmentDocumentResponse = z.infer<
  typeof UpdatePlantAssessmentDocumentResponseSchema
>

export const PlantAssessmentDocumentUrlResponseSchema = z.looseObject({
  url: z.string(),
  expiresAt: z.string()
})

export type PlantAssessmentDocumentUrlResponse = z.infer<
  typeof PlantAssessmentDocumentUrlResponseSchema
>
